import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter, Route, Switch, withRouter,
} from 'react-router-dom';
import i18next from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import Login from '../views/Login';
// eslint-disable-next-line import/no-named-as-default
import LoginPin from '../views/LoginPin';
import Transaction from '../views/Transaction';
import Subscription from '../views/Subscription';
// eslint-disable-next-line import/no-named-as-default
import Unsub from '../views/Unsub';
import URL_PATH from '../helpers/url';
import UseWindowSize from '../helpers/UseWindowSize';
import langEn from '../helpers/translations/en.json';
import langAr from '../helpers/translations/ar.json';
import langNo from '../helpers/translations/no.json';
import langMs from '../helpers/translations/ms.json';
import langMy from '../helpers/translations/my.json';
import langDa from '../helpers/translations/da.json';
import langSv from '../helpers/translations/sv.json';
import langSr from '../helpers/translations/sr.json';
import langMz from '../helpers/translations/mz.json';
import { GlobalStyles } from '../components/ui/globalStyles';
import { darkTheme, lightTheme } from '../components/ui/Themes';
import {
  clearLS, getLS, removeLS, setLS,
} from '../helpers/utils';

import Loginv2 from "../views/Loginv2";

i18next
  .use(detector)
  .use(initReactI18next)
  .init({
    // lng:           "en",
    interpolation: { escapeValue: false },
    detection: {
      // order:              [ "navigator","localStorage" ],
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
    },
    fallbackLng: 'en',
    // whitelist:   [ "en", "ar","no" ],
    resources: {
      en: { lang: langEn },
      ar: { lang: langAr },
      no: { lang: langNo },
      // ms: { lang: langMs },//malay ---based on google chrome langcode it supposed to be malay
      my: { lang: langMs },
      mm: { lang: langMy }, // myanmar
      // my: { lang: langMy },//myanmar --based on google chrome langcode it supposed to be burmese
      da: { lang: langDa }, // denmark
      sv: { lang: langSv }, // swedish
      se: { lang: langSv }, // swedish
      sr: { lang: langSr }, // serbian
      mz: { lang: langMz }, // mozambique
    },
  });

// eslint-disable-next-line react/prefer-stateless-function
class AppContainer extends Component {
  render() {
    return (

      <ThemeProvider theme={getLS('dark') === 'true' ? darkTheme : lightTheme}>
        <GlobalStyles />
        <BrowserRouter>
          <Switch>
            <Route exact path="/" render={(props) => <UseWindowSize><Loginv2 {...props} /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.LOGIN} render={(props) => <UseWindowSize><Loginv2 {...props} /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.LOGIN_PIN} render={(props) => <UseWindowSize><LoginPin {...props} /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.TRANSACTIONS} render={(props) => <UseWindowSize {...this.props}><Transaction {...props} /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.SUBSCRIPTIONS} render={(props) => <UseWindowSize {...this.props}><Subscription {...props} /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.UNSUBSCRIBE} render={(props) => <UseWindowSize {...this.props}><Unsub {...props} option="id" /></UseWindowSize>} />
            <Route path={URL_PATH.URLS.UNSUBSCRIBE_SHORTEN} render={(props) => <Unsub {...props} option="idc" />} />
            <Route path={URL_PATH.URLS.UNSUBSCRIBE2} render={(props) => <Unsub {...props} option="id" />} />
            <Route path={URL_PATH.URLS.UNSUBSCRIBEIDENTIFIER} render={(props) => <Unsub {...props} option="identifier" />} />
            <Route path={URL_PATH.URLS.UNSUBSCRIBEIDENTIFIER2} render={(props) => <Unsub {...props} option="identifier" />} />
          </Switch>

        </BrowserRouter>
      </ThemeProvider>

    );
  }
}

const mapStateToProps = (state) => ({ authentication: state.authentication });

export default withRouter(connect(mapStateToProps)(AppContainer));
